import { useTheme } from "next-themes";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import Header from "@/components/header/Header";
import useScrollToHash from "@/components/UseScrollToHash";
import useGetThemeMode from "@/hooks/useGetThemeMode";

type questionProps = {
  question: string;
  answer: string;
  anchor: string;
};

export default function TermsAndConditions() {
  const { hash } = useLocation();
  const { t } = useTranslation();

  const { setTheme } = useTheme();
  const { t: tTermsAndConditions } = useTranslation("termsandconditions");

  const theme = useGetThemeMode();
  if (theme) {
    setTheme(theme);
  }

  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState<questionProps[]>([]);
  const [anchorSelected, setAnchorSelected] = useState<string | null>(null);

  useScrollToHash(hash, setAnchorSelected);

  useEffect(() => {
    const termsandconditions = tTermsAndConditions(
      "termsandconditions",
      {
        returnObjects: true,
      }
    );

    if (Array.isArray(termsandconditions)) {
      setQuestions(termsandconditions as questionProps[]);
    } else {
      setQuestions([]);
    }

    setLoading(false);
  }, [hash, tTermsAndConditions]);

  function changeAnchorSelected(newAnchor: string | null) {
    if (newAnchor === anchorSelected) {
      newAnchor = null;
    }

    setAnchorSelected(newAnchor);
  }

  return (
    <div className="row justify-center">
      <Header
        title={t("help.legal_advice")}
        showLoading={loading}
        previousStepBackXTimes={1}
      />
      {!loading && questions != null && questions.length > 0 && (
        <div className="faq-container mt-1">
          <Accordion type="single"
            collapsible
            defaultValue={anchorSelected ? anchorSelected : undefined}
            className="w-full">
            {questions.map((q, i) => (
              <AccordionItem id={q.anchor} value={q.anchor} variant={"container"} key={q.anchor}>
                <AccordionTrigger onClick={() => changeAnchorSelected(q.anchor)}>{q.question}</AccordionTrigger>
                <AccordionContent>
                  <div className="faq_content" dangerouslySetInnerHTML={{ __html: q.answer || "" }} />
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
    </div>
  );
}
